import { render } from "./postponeDeliverGoodsList.vue?vue&type=template&id=e8bf0626&scoped=true"
import script from "./postponeDeliverGoodsList.vue?vue&type=script&lang=js"
export * from "./postponeDeliverGoodsList.vue?vue&type=script&lang=js"

import "./postponeDeliverGoodsList.vue?vue&type=style&index=0&id=e8bf0626&scoped=true&lang=css"
import "./postponeDeliverGoodsList.vue?vue&type=style&index=1&id=e8bf0626&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8bf0626"]])

export default __exports__